import React from 'react'
import { useTranslation } from 'react-i18next'

import Header from '@/components-latest/layout/Header'
import Text from '@/components-latest/primitives/Text'
import AutoAcceptSetting from '@/components-latest/ui/AccountPage/AutoAcceptSetting/AutoAcceptSetting'

import Styles from './OrderPreferencesPage.module.scss'

const OrderPreferencesPage = () => {
  const { t } = useTranslation()

  return (
    <div className={Styles.page}>
      <Header title={t('account.order-preferences.title')} />
      <div className={Styles.content}>
        <Text variant="title-1" asChild>
          <h1>{t('account.order-preferences.title')}</h1>
        </Text>
        <AutoAcceptSetting />
      </div>
    </div>
  )
}

export default OrderPreferencesPage
